import { createAction } from '@src/redux/helpers/createAction';
import { VERIFY_MEDICAID } from './constants';
import { verifyMedicaidSaga } from './sagas';

export const verifyMedicaid = (payload, onSuccess, onError) => {
  return createAction({
    type: VERIFY_MEDICAID,
    cache: false,
    meta: { onSuccess, onError, async: verifyMedicaidSaga },
    payload,
  });
};
